import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Typography from '@mui/material/Typography';
import { ALL_BUY_IN_AMOUNTS } from '../constants/buyInConstants';
import { selectMyNumChips } from '../redux/reducers/selfDataReducer';
import { useAppSelector } from '../redux/store';
import { getCurrencyAmountString } from '../utils/currencyUtils';
import { RebuyButton } from './rebuyButton';
import { ValueDisplay } from './valueDisplay';
function getRebuyElement(numChips, isSitting, roomSceneType) {
    function areChipsLowEnoughForRebuy() {
        if (roomSceneType === 'mttStaging') {
            // When joining an MTT (very often an automated MTT that uses the lowest buy-in), allow rebuying even when the player isn't totally broke,
            // as long as their chips are lower than the MTT's buy-in.
            // TODO: Consider making this number driven by the actual MTT buy-in, which would require an API refactor, as buy-in currently is communicated
            // in the MTT info HTML string.
            return numChips < ALL_BUY_IN_AMOUNTS[0];
        }
        else {
            // In any other room type, maybe show rebuy option when totally broke
            return numChips === 0;
        }
    }
    if (!areChipsLowEnoughForRebuy()) {
        return null;
    }
    if (isSitting) {
        // player has no chips in bank, but is sitting, so don't give the option to rebuy while still playing:
        return null;
    }
    if (roomSceneType !== 'poker' && roomSceneType !== 'mttStaging') {
        return (_jsx(Typography, { component: 'div', variant: 'caption', children: "(Free rebuy in any poker room or MTT staging room.)" }));
    }
    return (_jsx("div", { children: _jsx(RebuyButton, {}) }));
}
export const MyChipsDisplay = () => {
    const myNumChips = useAppSelector(selectMyNumChips);
    const roomSceneType = useAppSelector((state) => state.scene.roomSceneType);
    const isSitting = useAppSelector((state) => state.scene.roomSceneType === 'poker' && state.poker.mySeatIndex !== undefined);
    if (myNumChips === undefined) {
        return null;
    }
    const chipsStr = getCurrencyAmountString(myNumChips, 'chips');
    return (_jsxs("div", { children: [getRebuyElement(myNumChips, isSitting, roomSceneType), _jsx(ValueDisplay, { label: 'Chips', value: myNumChips, type: 'chips', title: `Chips in Bank: ${chipsStr}`, isLabelFirst: true })] }));
};
